import moment from 'moment-timezone';
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import * as auth from '~/utils/auth';
import * as i18n from '~/utils/i18n';
import * as adapi from '~/utils/adapi';
import Debug from '~/utils/debug';
import * as LocalStorage from '~/utils/local-storage';
import ProgressBar from '~/components/progress-bar/ProgressBar.vue';
import Submenu from './submenu/Submenu.vue';

const debug = Debug('header');

const allowRefresh = ['campaigns', 'customers', 'creatives'];
export default {
  props: {
    menuItems: {
      type: Object,
      default: () => {},
    },
    logo: {
      type: [String, Boolean],
      default: false,
    },
  },
  data() {
    return {
      language: 'en',
      availableLanguages: [],
      navOpen: false,
      windowWidth: window.innerWidth,
    };
  },
  components: {
    submenu: Submenu,
    'progress-bar': ProgressBar,
  },
  computed: {
    ...mapGetters('auth', { userFullName: 'fullName' }),
    ...mapState('publicConfig', {
      famUrl: state => (state.config && state.config.fam_url) || '#',
    }),
    notLoggedIn() {
      return this.userFullName === null;
    },
    showLanguageSelector() {
      return this.availableLanguages && this.availableLanguages.length > 1;
    },
    offlineModeEnabled() {
      return process.env.ENABLE_OFFLINE && this.userFullName;
    },
    topMenuItems() {
      return _.get(this.menuItems, 'top', []);
    },
    subMenuItems() {
      return _.get(this.menuItems, 'submenu', []);
    },
    isMobile() {
      return this.windowWidth <= 991;
    },
    getDynamicLogo() {
      if (this.logo) {
        return {
          backgroundImage: `url(${this.logo})`,
        };
      }
      return '';
    },
  },
  methods: {
    ...mapActions('publicConfig', ['updateConfig']),
    logout() {
      this.closeNavigation();
      auth.logout();
    },
    localeSelect(locale) {
      this.language = locale;
      if (this.userFullName) {
        adapi.post('users/update-profile', null, {
          selected_language: locale,
        })
          .catch(e => debug.error(e));
      }
      return i18n.setLocale(locale);
    },
    updateMomentTranslations() {
      const months = [];
      const monthsShort = [];

      for (let month = 1; month <= 12; month += 1) {
        months.push(this.$t('fn.complex.months_long', { month }));
        monthsShort.push(this.$t('fn.complex.months_short', { month }));
      }

      moment.updateLocale('en', {
        months,
        monthsShort,
        relativeTime: {
          past: this.substitute('past', '%s'),
          s: this.substitute('second'),
          ss: this.substitute('second_plural'),
          m: this.substitute('minute'),
          mm: this.substitute('minute_plural'),
          h: this.substitute('hour'),
          hh: this.substitute('hour_plural'),
          d: this.substitute('day'),
          dd: this.substitute('day_plural'),
          M: this.substitute('month'),
          MM: this.substitute('month_plural'),
          y: this.substitute('year'),
          yy: this.substitute('year_plural'),
        },
      });
    },
    substitute(key, to = '%d') {
      return this.$t(`terms.datetime.${key}`, { count: to });
    },
    closeNavigation() {
      this.$refs.headerNav.show = false;
    },
    getActiveClass(name) {
      return this.$route.name === name;
    },
    onNavigateTo(to) {
      if (this.$route.name === to.name && _.indexOf(allowRefresh, this.$route.name) !== -1) {
        adapi.eventBus.$emit('refreshSelf');
      }
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (id, value) => {
      if (this.$refs.headerNav && id === this.$refs.headerNav.$el.id) {
        this.navOpen = value;
      }
    });
    this.availableLanguages = i18n.getAvailableLocales();

    LocalStorage.get('locale')
      .then(locale => {
        if (locale) {
          this.locale = locale;
        }
      });

    window.addEventListener('resize', this.handleWindowResize);
    this.updateMomentTranslations();
    i18n.eventBus.$on('language-changed', this.updateMomentTranslations);
  },
  updated() {
    Object.values(this.$el.getElementsByClassName('nav-item')).forEach(item => {
      Object.values(item.getElementsByTagName('A')).forEach(link => {
        let linkName = link.getAttribute('href').replace(/\//g, '_');
        if (linkName === '_') {
          linkName = '_home';
        }
        if (linkName && linkName.length !== 0 && linkName !== '#') {
          link.setAttribute('name', `link_header_to${linkName}`);
        }
      });
    });
  },
  watch: {
    $route() {
      if (this.navOpen) {
        this.closeNavigation();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    i18n.eventBus.$off('language-changed', this.updateMomentTranslations);
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/header/Header.js